import { computed, Ref } from 'vue';

interface LoadingState {
    isLoading: Ref<boolean>;
    error: Ref<string | null>;
}

export function useCombinedStates(...states: LoadingState[]): LoadingState {
    const isAnyLoading = (states: LoadingState[]) => {
        return states.some((s) => s.isLoading.value);
    };

    const findFirstError = (states: LoadingState[]) => {
        const first = states.find((e) => e.error.value !== null);
        return first?.error.value || null;
    };

    return {
        isLoading: computed(() => isAnyLoading(states)),
        error: computed(() => findFirstError(states))
    };
}
